<template>
  <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="45%" @close="handleClose"
    :close-on-click-modal="false">
    <el-form :model="currentData" label-width="100px" ref="form" :rules="rules" v-loading="formLoadng">

      <el-form-item label="名称：" prop="name">
        <el-input size="mini" v-model="currentData.name" />
      </el-form-item>

      <!-- 绑定设备 -->
      <el-form-item label="绑定设备：" prop="bind_dev">
        <el-checkbox v-model="currentData.bind_dev"></el-checkbox>
      </el-form-item>

      <!-- 设备地址 -->
      <el-form-item label="设备地址：" prop="dev_addr" v-if="currentData.bind_dev">
        <el-select v-model="currentData.dev_addr" size="mini">
          <el-option v-for="item in ipList" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <!-- 机架号 -->
      <el-form-item label="机架号" prop="rack">
        <el-select size="mini" v-model="currentData.rack">
          <el-option v-for="item in rackList" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <!-- 槽位 -->
      <el-form-item label="槽位" prop="slot">
        <el-select size="mini" :options="slotList" v-model="currentData.slot">
          <el-option v-for="item in slotList" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <!-- 地址域 -->
      <el-form-item label="地址域" prop="area">
        <el-select size="mini" v-model="currentData.area">
          <el-option v-for="item in areaList" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <!-- DB号 -->
      <el-form-item label="DB号" prop="dbnum">
        <el-input size="mini" v-model="currentData.dbnum"></el-input>
      </el-form-item>

      <el-form-item label="起始地址：" prop="start">
        <el-input size="mini" v-model="currentData.start" />
        <p class="tips">
          取值范围: 0 ~ 65535
        </p>
      </el-form-item>

      <el-form-item label="数据类型：" prop="datatype">
        <el-select size="mini" v-model="currentData.datatype" style="width: 100%;" placeholder="请选择">
          <el-option v-for="item in dataTypeList" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="精度" prop="precise"
        v-if="currentData.datatype === 'float' || currentData.datatype === 'double'">
        <el-input size="mini" v-model="currentData.precise" placeholder="请输入"></el-input>
        <p class="tips">取值范围: 1 ~ 6</p>
      </el-form-item>
      <el-form-item label="数据长度：" prop="size">
        <el-input size="mini" v-model="currentData.size" />
        <p class="tips">取值范围: 1 ~ 30</p>
      </el-form-item>

      <!-- 字节序 -->
      <el-form-item label="字节序：" prop="endian">
        <el-select size="mini" v-model="currentData.endian">
          <el-option v-for="item in byteList" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="计算因子：" prop="factor" v-if="!['bool', 'string', 'raw', ''].includes(currentData.datatype)">
        <el-input size="mini" v-model="currentData.factor" placeholder="请输入"></el-input>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirmAdd">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listConfig, updateConfig } from "@/api/configurationlist";
export default {
  data() {
    var validateslaveid = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入从站ID'));
      } else if (isNaN(value)) {
        callback(new Error('请输入1-255之间的数字'));
      } else if (value < 1 || value > 255) {
        callback(new Error('从站ID范围1-255'));
      } else {
        callback();
      }
    };
    var validatestart = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入起始地址'));
      } else if (isNaN(value)) {
        callback(new Error('请输入0-65535之间的数字'));
      } else if (value < 0 || value > 65535) {
        callback(new Error('起始地址范围0-65535'));
      } else {
        callback();
      }
    };
    var validateprecise = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入精度'));
      } else if (isNaN(value)) {
        callback(new Error('精度范围1-6'));
      } else if (value < 0 || value > 65535) {
        callback(new Error('精度范围1-6'));
      } else {
        callback();
      }
    };
    var validatefactor = (rule, value, callback) => {
      // 必须为正整数
      if (value === '') {
        callback(new Error('请输入计算因子'));
      } else if (isNaN(value)) {
        callback(new Error('计算因子必须为数字'));
      } else {
        callback();
      }
    }
    var validatesize = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入数据长度'));
      } else if (isNaN(value)) {
        callback(new Error('数据长度范围1-30'));
      } else if (value < 0 || value > 65535) {
        callback(new Error('数据长度范围1-30'));
      } else {
        callback();
      }
    };
    return {
      currentData: {
        name: '',
        dev_addr: '',
        start: '',
        datatype: 'bool',
        size: '',
        precise: '',
        factor: '',
        sname: undefined,
        index: undefined,
        bind_dev: false,
        endian: 'ABCD',
        rack: '0',
        area: 'DB',
        dbnum: '0',
        slot: '0'
      },
      ipList: [],
      dialogTitle: '编辑',
      formLoadng: false,
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        start: [
          { validator: validatestart, trigger: 'blur' }
        ],
        precise: [
          { validator: validateprecise, trigger: 'blur' }
        ],
        size: [
          { validator: validatesize, trigger: 'blur' }
        ],
        factor: [
          { validator: validatefactor, trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      byteList: [
        {
          label: 'ABCD',
          value: 'ABCD'
        },
        {
          label: 'CDAB',
          value: 'CDAB'
        },
        {
          label: 'DCBA',
          value: 'DCBA'
        },
        {
          label: 'BADC',
          value: 'BADC'
        },
      ],
      rackList: [],
      slotList: [],
      areaList: [
        {
          label: 'DB',
          value: 'DB'
        },
        {
          label: 'Digital Inputs',
          value: 'Digital Inputs'
        },
        {
          label: 'Digital Outputs',
          value: 'Digital Outputs'
        },
        {
          label: 'Merkers',
          value: 'Merkers'
        },
        {
          label: 'Timers',
          value: 'Timers'
        },
        {
          label: 'Counters',
          value: 'Counters'
        },
      ]
    };
  },
  props: ['deviceSn', 'deviceDid'],
  methods: {
    async getDevIp() {
      const resp = await listConfig(this.deviceSn, this.deviceDid, [
        {
          "section": "conn",
          config: "smartlink",
          options: [
            {
              option: 'mode'
            },
            {
              option: 'dev_name'
            }
          ],
          lists: [
            {
              list: 'server'
            },
          ]
        }
      ])
      if (!resp.data.success) {
        return this.$message.error('操作失败')
      }
      let sml = resp.data.data.mess[0].s_objects;
      
      sml.forEach((item) => {
        if (item.options.mode === 'S7 Client') {
          // if (item.options.dev_name != '') {
          //   this.ipList.push({
          //     label: item.options.dev_name,
          //     value: item.options.dev_name
          //   })
          // }
          this.ipList.push(...item.lists.server.map((e) => {
            return {
              label: e,
              value: e
            }
          }))
        }
      })

    },
    handleClose() {

    },
    confirmAdd() {
      this.$emit('update', this.currentData)
    }
  },
  mounted() {
    for (let i = 0; i < 19; i++) {
      if (i < 4) {
        this.rackList.push({
          label: i.toString(),
          value: i.toString()
        })
      }
      this.slotList.push({
        label: i.toString(),
        value: i.toString()
      })
    }
    this.getDevIp()
  },
  computed: {
    dataTypeList() {
      return [
        {
          label: 'bool',
          value: 'bool'
        },
        {
          label: 'int16',
          value: 'int16'
        },
        {
          label: 'uint16',
          value: 'uint16'
        },
        {
          label: 'int32',
          value: 'int32'
        },
        {
          label: 'uint32',
          value: 'uint32'
        },
        {
          label: 'int64',
          value: 'int64'
        },
        {
          label: 'uint64',
          value: 'uint64'
        },
        {
          label: 'float',
          value: 'float'
        },
        {
          label: 'double',
          value: 'double'
        },
        {
          label: 'string',
          value: 'string'
        },
        {
          label: 'raw',
          value: 'raw'
        }
      ]
    }
  },
};
</script>
<style scoped></style>